import { Twitch, Instagram, Music2, Twitter, MessageCircle, Youtube, ArrowUpRight } from "lucide-react";

export const PLATFORM_META = {
  TWITCH: { Icon: Twitch, color: "TWITCH" },
  INSTAGRAM: { Icon: Instagram, color: "INSTAGRAM" },
  TIKTOK: { Icon: Music2, color: "TIKTOK" },
  X: { Icon: Twitter, color: "X / TWITTER" },
  DISCORD: { Icon: MessageCircle, color: "DISCORD" },
  YOUTUBE: { Icon: Youtube, color: "YOUTUBE" },
};

export const Arrow = ArrowUpRight;
